module.exports = __webpack_public_path__ + "assets/7a3fb674be648f8a9a36382b62b3893f.png";